{
  "overview.greeting_morning": "Goedemorgen, {name}",
  "overview.greeting_afternoon": "Goedemiddag, {name}",
  "overview.greeting_evening": "Goedenavond, {name}",
  "overview.overdue": "Te laat",
  "overview.manage": "Beheren",
  "overview.revision": "Revisie {revision}",
  "overview.ai_budget": "AI-budget",
  "overview.ai_this_month": "Deze maand",
  "overview.ai_no_budget": "Geen budget ingesteld",
  "overview.activity": "Recente activiteit",
  "overview.no_activity": "Nog geen activiteit.",
  "overview.summary": "{count, plural, one {Eén punt vraagt vandaag je aandacht.} other {# punten vragen vandaag je aandacht.}}",
  "overview.summary_none": "Alles is bijgewerkt.",
  "overview.focus": "Waar je vandaag aan werkt",
  "overview.attention": "Nu aandacht nodig",
  "overview.attention_empty_title": "Alles is bijgewerkt",
  "overview.attention_empty_body": "Nieuwe aanvragen, taken en teksten verschijnen hier zodra ze er zijn.",
  "overview.filter_clear": "Alles tonen",
  "overview.stat_leads": "{count, plural, one {nieuwe aanvraag} other {nieuwe aanvragen}}",
  "overview.stat_tasks": "{count, plural, one {taak voor vandaag} other {taken voor vandaag}}",
  "overview.stat_texts": "{count, plural, one {tekst te doen} other {teksten te doen}}",
  "overview.stat_imports": "{count, plural, one {import wacht} other {imports wachten}}",
  "overview.stat_channels": "{count, plural, one {portaalafwijzing} other {portaalafwijzingen}}",
  "overview.row_reviews": "{count, plural, one {# tekst wacht op je review} other {# teksten wachten op je review}}",
  "overview.row_reviews_meta": "Voorstellen in jouw talen",
  "overview.row_stale": "{count, plural, one {# vertaling is verouderd} other {# vertalingen zijn verouderd}}",
  "overview.row_stale_meta": "De brontekst is gewijzigd sinds de vertaling",
  "overview.row_imports": "{count, plural, one {# import wacht op controle} other {# imports wachten op controle}}",
  "overview.row_imports_meta": "Bekijk de verschillen voordat je ze toepast",
  "overview.row_channels": "{count, plural, one {# portaalvermelding afgewezen} other {# portaalvermeldingen afgewezen}}",
  "overview.row_channels_meta": "Het portaal gaf een reden; los die op en lever opnieuw",
  "overview.row_failures": "{count, plural, one {# achtergrondtaak mislukt} other {# achtergrondtaken mislukt}}",
  "overview.row_failures_meta": "Bekijk de diagnose bij Instellingen",
  "overview.due_today": "Vandaag",
  "overview.site_view": "Site bekijken",
  "overview.site_live": "Live",
  "overview.site_not_live": "Nog niet live",
  "overview.site_preview_line": "Preview: revisie {revision}, {when} geleden"
}
